import request from "@/utils/request";

export function getPageList(data) {
  return request({
    url: "/BedTagsManagement/GetPageList",
    method: "post",
    data
  });
}
export function update(data) {
  return request({
    url: "/BedTagsManagement/Edit",
    method: "post",
    data
  });
}
export function addParent(data) {
  return request({
    url: "/BedTagsManagement/AddParent",
    method: "post",
    data
  });
}

export function addChild(data) {
  return request({
    url: "/BedTagsManagement/AddChild",
    method: "post",
    data
  });
}
export function del(data) {
  return request({
    url: "/BedTagsManagement/Delete",
    method: "delete",
    params: data
  });
}
export function GetChildrent(params) {
  return request({
    url: "/BedTagsManagement/GetChildrent",
    method: "get",
    params
  });
}

export function CopyTags(data) {
  return request({
    url: "/BedTagsManagement/CopyTags",
    method: "post",
    data
  });
}
